import { requestEnvelopeV2 } from './client'
import { rescueFlowSchema, type RescueFlow } from './schemas'

/** 救援流向：事件维度的任务 / 志愿者轨迹 / 证据（需 tasks.read 权限） */
export async function getRescueFlow(eventId: string): Promise<RescueFlow> {
  return requestEnvelopeV2(`/events/${encodeURIComponent(eventId)}/rescue-flow`, rescueFlowSchema)
}
